"use strict";
// #region sections appearance effect
var sections = document.querySelectorAll(".hidden");
var menu = document.querySelector(".menu");
var initialScroll = true;
var toggleSectionVisibility = function() {
    sections.forEach(function(section) {
        var sectionTop = section.getBoundingClientRect().top;
        var sectionBottom = section.getBoundingClientRect().bottom;
        var windowHeight = window.innerHeight;
        if (sectionTop < windowHeight - 20 && sectionBottom > 20) section.classList.add("visible");
        else if (!section.classList.contains("top-bar")) section.classList.remove("visible");
    });
};
var handleScroll = function() {
    if (initialScroll) {
        window.scrollTo(0, 0);
        initialScroll = false;
    }
    if (menu.style.display !== "block") toggleSectionVisibility();
};
window.addEventListener("scroll", handleScroll);
document.addEventListener("DOMContentLoaded", handleScroll); // #endregion

//# sourceMappingURL=index.1e1971a0.js.map
